/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceResourceDetailsListRequest {
    getFixupPrototypeFunction() { return ServiceResourceDetailsListRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceResourceDetailsListRequest>): ServiceResourceDetailsListRequest {
        let obj = Object.assign(new ServiceResourceDetailsListRequest(), model);
        ServiceResourceDetailsListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceResourceDetailsListRequest>): ServiceResourceDetailsListRequest {
        if (!model) return null;
        return ServiceResourceDetailsListRequest.newInstance(<ServiceResourceDetailsListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceResourceDetailsListRequest) {
        if (!obj) return;

        models.ServiceResourceDetailsListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceResourceDetailsListRequest): boolean {
        Object.setPrototypeOf(obj, ServiceResourceDetailsListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ServiceResourceDetailsFilter.fixupPrototype(this.filters);
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Filters for the request
     */
    filters: models.ServiceResourceDetailsFilter;

}
